"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const malty_theme_malty_theme_provider_1 = require("@carlsberggroup/malty.theme.malty-theme-provider");
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const Text_styled_1 = require("./Text.styled");
const Text_types_1 = require("./Text.types");
function Text({ textStyle = Text_types_1.TextStyle.MediumDefault, align = Text_types_1.TextAlign.Left, color = Text_types_1.TextColor.DigitalBlack, italic = false, as = 'p', ellipsis = false, children, width, className, dataQaId }) {
    const theme = (0, react_1.useContext)(styled_components_1.ThemeContext) || malty_theme_malty_theme_provider_1.globalTheme;
    let StyledTag = as;
    switch (as) {
        case 'span':
            StyledTag = 'span';
            break;
        default:
            StyledTag = 'p';
            break;
    }
    return (react_1.default.createElement(Text_styled_1.StyledParagraph, { "data-testid": dataQaId, textStyle: textStyle, color: color, align: align, italic: italic, ellipsis: ellipsis, width: width, theme: theme, as: StyledTag, className: className }, children));
}
exports.Text = Text;
//# sourceMappingURL=Text.js.map